import React from "react";
import {
    Button,
    Space,
    Typography,
    List,
    Card, Tooltip,
    notification
} from "antd";
import {CloseOutlined, EditOutlined, SaveOutlined} from '@ant-design/icons'
import {getFeConfig, visualize, updateEASInfo, updateSelfRegPassphrase} from "../api/api";
import {resolve} from "@q4us-sw/q4us-ui/lib/Cell";
import {EditCellView, RowContext} from "@q4us-sw/q4us-ui/lib/TableV2";
import {unstable_batchedUpdates} from "react-dom";
import {Q4USUtil} from "@q4us-sw/q4us-util";
import moment from "moment";


export const Item = ({column, value: v, submit}) => {

    const [edit, setEdit] = React.useState(false)
    const [display, setDisplay] = React.useState(v)
    const [value, setValue] = React.useState({data: {[column.name]: v}})


    return <Card
        className={`eas-info-item`}
        title={<Tooltip title={column.title}>{column.title}</Tooltip>}
        extra={<Space>
            {(!edit) && <Button icon={<EditOutlined/>} key={"edit"} onClick={() => setEdit(true)}/>}
            {edit && <Button icon={<SaveOutlined/>} key={"save"} onClick={async () => {
                const [[p, q]] = Object.entries(value.data);
                let res = {status: 200};
                if (submit) {
                    await submit({key: p, value: q}).catch(e => {
                        res = {status: 401}
                    })
                } else {
                    const date = new Date();
                    const todayDate = date.getDate();
                    const prevMonth = moment().subtract(1, "month").startOf("month").format('MMMM');

                    const {REACT_APP_DEMO_MODE = undefined} = process.env;

                    if(p==='post_sale_grace_period_days' && (q < 0 || q > 15)){
                        notification.error({message: "Grace period is invalid"});
                        res = {status : 406}
                    }
                    else if(p==='post_sale_grace_period_days' && (todayDate > display && todayDate < q) && !REACT_APP_DEMO_MODE) {
                        notification.error({message: `Grace period can’t be changed to selected date because Invoices already generated for ${prevMonth}` });
                        res = {status : 406}
                    }

                    else if(p==='post_sale_grace_period_days' && (todayDate < display && todayDate > q) && !REACT_APP_DEMO_MODE){
                        notification.error({message: `Grace period can’t be changed to selected date because Invoices will not be generated for ${prevMonth}`});
                        res = {status : 406}
                    }
                    else{
                        res = await updateEASInfo({key: p, value: q})
                    }
                }
                if (res.status === 200) {
                    unstable_batchedUpdates(() => {
                        setEdit(false)
                        setDisplay(q)
                    })
                } else {
                    unstable_batchedUpdates(() => {
                        setEdit(false)
                        setValue({data: {[column.name]: v}})
                    })
                }

            }}/>}
            {edit && <Button icon={<CloseOutlined/>} key={"close"} onClick={async () => {
                unstable_batchedUpdates(() => {
                    setEdit(false)
                    setValue({data: {[column.name]: v}})
                })
            }}/>}
        </Space>}
    >
        {(!edit) && <Typography.Text className={`eas-info-value`}>
            {column.type === 'NUMBER' && column.enums == null ? Q4USUtil.roundToDecimal((display || 0), column.precision).toFixed(column.precision) : resolve({
                ...column,
                value: display,
                precision: 2
            })}
        </Typography.Text>}
        {edit && <RowContext.Provider value={{edit: value, setEdit: setValue, row: value.data, index: 0}}>
            <EditCellView required={true} name={column.name} type={column.type} title={column.title} enums={column.enums}/>
        </RowContext.Provider>}
    </Card>
}


export const Info = (props) => {

    const [opt, setOpt] = React.useState({config: [], data: {}})

    const load = async () => {
        const {data: {rows: config} = {}} = await getFeConfig('eas_info') || {};
        const {data: {rows = []} = {}} = await visualize('eas_info') || {};

        const data = rows.reduce((acc, {name, value, type}) => {
            acc[name] = type === 'NUMBER' ? Number(value) : type === 'BOOLEAN' ? value === 'true' : value;
            return acc;
        }, {})
        setOpt({config, data})

    }

    const changeSelfRegPassphrase = async ({key, value}) => {
        await updateSelfRegPassphrase(value)
        return true;
    }



    React.useEffect(() => {
        load();
    }, [])

    return <React.Fragment>
        <div className={`eas-info-wrap`}>
            <List
                grid={{
                    gutter: 16,
                    xs: 1,
                    sm: 2,
                    md: 2,
                    lg: 2,
                    xl: 4,
                    xxl: 4
                }}
                dataSource={opt.config}
                renderItem={item => <List.Item>
                    <Item column={item} value={opt.data[item.name]}
                          submit={item.name === 'self_reg_passphrase' ? changeSelfRegPassphrase : undefined}/>
                </List.Item>}
            />
        </div>
    </React.Fragment>

}
